import { MediaBreakpointQueries } from "@literati/public-ui-shared-react";
import { useEffect, useState } from "react";

type Breakpoint = MediaBreakpointQueries[keyof MediaBreakpointQueries];

export const useMediaQuery = (query: Breakpoint) => {
  const [matches, setMatches] = useState(
    () =>
      typeof window !== "undefined" &&
      window?.matchMedia(query.replace("@media", "")).matches
  );

  useEffect(() => {
    const media = window.matchMedia(query.replace("@media", ""));
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => setMatches(media.matches);
    window.addEventListener("resize", listener);
    return () => window.removeEventListener("resize", listener);
  }, [matches, query]);

  return matches;
};
